import * as React from "react";
import { observer, inject } from "mobx-react";

import { CommitteeStore } from "../../stores";
import { Committee } from "Stores/committeeStore";
import { Utils } from "../../common/utils";

import { Button, Col, Form, Modal, Row, Spinner } from "react-bootstrap";


interface CommitteeFormModalState {
    isCreatingOrUpdating: boolean
    isAdmin: boolean
    id: number
    name: string
}

interface CommitteeFormModalProps {
    committeeStore?: CommitteeStore
    selectedCommittee?: Committee
    handleSubmitCommittee: () => void
    handleCloseModal: () => void
}


@inject("committeeStore")
@observer
export class CommitteeFormModal extends React.Component<CommitteeFormModalProps, CommitteeFormModalState> {
    state = {
        isAdmin: Utils.hasAdminAccess(),
        isCreatingOrUpdating: false,
        name: this.props.selectedCommittee ?this.props.selectedCommittee.name :"",
        id: this.props.selectedCommittee ? this.props.selectedCommittee.id : -1
    };

    saveCommittee = () => {
        if(!this.props.committeeStore) return;

        this.setState({isCreatingOrUpdating: true},() => {
            const committee: Committee = Object.assign({},this.props.selectedCommittee, {
                id: this.state.id,
                name: this.state.name
            });

            if(this.props.selectedCommittee){
                Promise.resolve(this.props.committeeStore!.updateCommittee(committee).then(() => {
                    this.setState({isCreatingOrUpdating: false});
                    this.props.handleSubmitCommittee();
                }));
            }
            else {
                Promise.resolve(this.props.committeeStore!.createCommittee(committee.name).then(() => {
                    this.setState({isCreatingOrUpdating: false});
                    this.props.handleSubmitCommittee();
                }));
            }
        });

    };

    handleSubmit = (ev) => {
        ev.preventDefault();
        if(this.props.committeeStore && !this.props.committeeStore.isProcessing && !this.state.isCreatingOrUpdating){
            this.saveCommittee();
        }
    };

    handleCloseClick = () => {
        this.props.handleCloseModal();
    };

    handleNameChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({name: ev.target.value});
    };

    renderForm = () => {
        const { selectedCommittee, committeeStore } = this.props;
        if( !committeeStore ) return null;
        const isSaving = committeeStore.isProcessing || this.state.isCreatingOrUpdating;
        const saveButtonContent = isSaving ? <Spinner animation="border" className="green-spinner" /> : "Save";
        return (
            <>
                <Modal.Body className="edit">
                    <div className="header edit">
                        <span>{selectedCommittee ? "Edit" : "Create"} Committee</span>
                    </div>
                    <Row>
                        <Col>
                            <form onSubmit={this.handleSubmit}>
                                <Row>
                                    <Form.Group className="mb-3" as={Col}>
                                        <Form.Label>Name:</Form.Label>
                                        <Form.Control type="text" onChange={ this.handleNameChange } required={ true } value={this.state.name}/>
                                    </Form.Group>
                                </Row>
                                <Row className="button-bar">
                                    <Col className="text-end">
                                        <Button
                                            variant="secondary"
                                            size="lg"
                                            id="committee-form-cancel"
                                            disabled={isSaving}
                                            onClick={this.handleCloseClick}
                                            style={{marginRight: 15}}>
                                            Cancel
                                        </Button>
                                        <Button
                                            variant="primary"
                                            size="lg"
                                            id="committee-form-save"
                                            disabled={!this.state.name || isSaving}
                                            onClick={this.saveCommittee}>
                                            {saveButtonContent}
                                        </Button>
                                    </Col>
                                </Row>
                            </form>
                        </Col>
                    </Row>
                </Modal.Body>
            </>
        );
    };

    handleDismiss = () => {
        this.props.handleCloseModal();
    };

    componentDidMount() {
        if(!this.props.selectedCommittee){
            Utils.pushViewName("CreateCommittee");
        } else {
            Utils.pushViewName("EditCommittee");
        }
    }

    componentWillUnmount() {
        Utils.popViewName();
    }

    render() {
        const {committeeStore} = this.props;

        if(!committeeStore) {
            return (<div>No committees loaded. Please try again.</div>);
        } else {
            return (
                <Modal show={ true } centered
                    onHide={ this.handleDismiss }>
                    { this.renderForm() }
                </Modal>
            );
        }
    }
}
